var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":_vm.tooltipTop,"bottom":_vm.tooltipBottom,"left":_vm.tooltipLeft},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
var tooltipAttrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"small":_vm.smallTriggerIcon}},'v-icon',tooltipAttrs,false),tooltip),[_vm._v(" "+_vm._s(_vm.iconName)+" ")])]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }